import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CarouselControls, CarouselNavigation, CarouselPagination, CarouselSlide, Carousel as DSCarousel } from "@cinch-labs/design-system";
import cx from "classnames";
import styles from "./why-cinch-carousel.module.css";
import { WhyBuyContentCard } from "..";
import { tagError } from "@core/datadog-server";
function chunkArray(arr, size) {
    return Array.from({
        length: Math.ceil(arr.length / size)
    }, function(v, i) {
        return arr.slice(i * size, i * size + size);
    });
}
export var WhyCinchCarousel = function(param) {
    var content = param.content, carouselName = param.carouselName;
    var navAriaLabels = {
        previous: "Go to previous slide",
        next: "Go to next slide"
    };
    var groupSize = 2;
    var groupedCards = [];
    try {
        groupedCards = chunkArray(content, groupSize);
    } catch (error) {
        if (_instanceof(error, Error) || typeof error === "string") {
            tagError(error);
        }
        groupedCards = [];
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(DSCarousel, {
                name: carouselName,
                swiperSettings: {
                    slidesPerView: 1,
                    spaceBetween: 16,
                    breakpoints: {
                        564: {
                            slidesPerView: 1
                        }
                    }
                },
                ariaLabel: "".concat(carouselName, "-carousel"),
                children: groupedCards.map(function(group, index) {
                    return /*#__PURE__*/ _jsx(CarouselSlide, {
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles.groupedCardWrapper,
                            children: group.map(function(content) {
                                return /*#__PURE__*/ _jsx(WhyBuyContentCard, {
                                    content: content
                                }, "".concat(content.title));
                            })
                        })
                    }, "group-".concat(index));
                })
            }),
            /*#__PURE__*/ _jsxs(CarouselControls, {
                customClassNames: styles.controlsWrapper,
                children: [
                    /*#__PURE__*/ _jsx(CarouselPagination, {
                        name: carouselName,
                        customClassNames: cx("".concat(carouselName, "-pagination"), styles.pagination, styles.customPagination),
                        "data-testid": "ds-carousel-pagination",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ _jsx(CarouselNavigation, {
                        name: carouselName,
                        ariaLabels: navAriaLabels,
                        ariaHidden: true,
                        customClassNames: {
                            prevButton: styles.prevButton,
                            nextButton: styles.nextButton
                        }
                    })
                ]
            })
        ]
    });
};
